import React from 'react';
import { Spin } from 'antd';
import './Loadding.css';

interface LoaddingProps {
  title?: string;
  subtitle?: string;
}

const Loadding: React.FC<LoaddingProps> = ({ 
  title = "PHẦN MỀM NHÂN SỰ", 
  subtitle = "Đang tải dữ liệu..." 
}) => {
  return (
    <div className="loading-container">
      <div className="loading-card">
        <div className="loading-spinner-wrapper">
          <Spin size="large" />
        </div>
        <h2 className="loading-title">
          {title}
        </h2>
        <p className="loading-subtitle">
          {subtitle}
        </p>
      </div>
    </div>
  );
};

export default Loadding;
